// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_gaA","cls2":"LettersModal-cls2_LCI LettersModal-cls1_gaA"};